import type { PublishChannel } from '@/api/publishChannels';

/**
 * A store the seller can send to: installed and fed by DesignDeck. A pull
 * store is fetched by the partner app, so it stays a column in the overview
 * but is never a target. Absent mode means push (an API from before the
 * field existed).
 */
export function isSendableChannel(channel: PublishChannel): boolean {
  return channel.isActive && channel.deliveryMode !== 'PULL';
}
